<template>
  <v-container fluid>
    <intro-image/>
    <v-lazy
      v-model="isActive"
      :options="{threshold: .5}"
      min-height="200"
    >
      <div class="content" v-html="page.tekst_2"/>
    </v-lazy>
    <v-carousel
      v-model="carousel"
      class="carousel"
      hide-delimiters
      height="100%"
      :show-arrows="false"
      cycle
      continuous
    >
      <v-carousel-item v-for="testimonial in testimonials" :key="testimonial.customer">
        <v-row class="testimonial secondary lighten-2 py-12 pa-md-12" align="center" justify="center">
          <v-col
            tag="figure"
            cols="12"
            sm="6"
            lg="5"
            xl="4"
            :class="{'testimonial__image': $breakpoint.is.smAndUp}"
            class="pa-0"
          >
            <v-img :src="testimonial.image" :alt="testimonial.customer" :aspect-ratio="2"/>
          </v-col>
          <v-col
            cols="12"
            sm="5"
            md="4"
            xl="3"
            :class="{'testimonial__mobile': $breakpoint.is.xsOnly}"
            class="pt-10 pl-10 pt-sm-3 pl-sm-3 ml-sm-12"
          >
            <h3>
              Deze klanten<br>
              vertellen:
            </h3>
            <div v-html="testimonial.testimonial"/>
            <span class="font-weight-bold">- {{ testimonial.customer }}, {{ testimonial.city }}</span>
          </v-col>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </v-container>
</template>

<script>
import page from '~/plugins/mixins/page';
import IntroImage from '~/components/IntroImage';

export default {
  components: {
    IntroImage,
  },
  mixins: [page],
  async asyncData({$axios, error}) {
    try {
      const {data} = await $axios.get('/testimonials');

      return {
        testimonials: data.data,
      };
    } catch (e) {
      error({statusCode: 503, message: e.message});
    }
  },
  data() {
    return {
      isActive: false,
      carousel: 0,
      testimonials: [],
    };
  },
};
</script>

<style lang="sass" scoped>
.content
  ::v-deep .row
    .col-12
      display: flex
      flex-direction: column
      justify-content: center
      padding: 0
      align-self: stretch

      figure
        height: 100%
        position: relative
        img
          height: 100%
          width: 100%
          object-fit: cover
          position: relative
          z-index: 2

    &:nth-of-type(odd)
      figure
        &::before
          content: ''
          position: absolute
          top: -9%
          bottom: 0
          left: 0
          right: 7%
          background: var(--v-primary-lighten1)
          z-index: 1

        img
          padding-left: 6%

    &:nth-of-type(2)
      figure
        &::before
          content: ''
          position: absolute
          top: -9%
          bottom: 0
          left: 7%
          right: 0
          background: var(--v-primary-base)
          z-index: 1

        img
          padding-right: 6%

      .col-12
        &:nth-of-type(1)
          order: 1
        &:nth-of-type(2)
          order: 4
          @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
            order: 2
        &:nth-of-type(3)
          order: 3
        &:nth-of-type(4)
          order: 2
          @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
            order: 4
        &:nth-of-type(5)
          order: 5

    &:nth-of-type(3)
      @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
        margin-bottom: 100px

.testimonial
  h3
    font-size: 46px
    line-height: 42px
    @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
      font-size: 32px
      line-height: 32px
    @media screen and (min-width: map-get($grid-breakpoints, 'md'))
      line-height: 42px

  &__image
    position: relative

    &::before
      content: ''
      position: absolute
      top: 0
      bottom: 0
      right: -20px
      width: 4px
      background-image: url('~assets/img/line.png')

  &__mobile
    position: relative

    &::before
      content: ''
      position: absolute
      top: 20px
      bottom: -8px
      left: 12px
      width: 4px
      background-image: url('~assets/img/line.png')
</style>
